import { Controller, useFormContext } from "react-hook-form";
import { TimeInput, TimeInputProps } from "./time-input";

export type ControlledTimeInputProps = Omit<
  TimeInputProps,
  "onChange" | "value"
> & {
  name: string;
};

export function ControlledTimeInput({
  name,
  ...props
}: ControlledTimeInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        return (
          <TimeInput
            {...props}
            {...field}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error?.message}
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
            }}
          />
        );
      }}
    />
  );
}
